import React, { useState } from "react";
import { EntityRegistry } from "../EntityRelationsManager";
import { EntityRelationAddon } from "../EntityRelationAddon";
import I18n from "../../../../../../core/localization/I18n";
import { StepType } from "../../../types/types";
import { EntityValidationProgress } from "./EntityValidationProgress";
import "./_entity-relation-validation.scss";

export const EntityValidationComponent: React.FC<{
  entityRegistry: EntityRegistry;
  entityAddons: EntityRelationAddon[];
  uploadedData: any[];
  currentEntity: EntityRelationAddon | null;
  processedEntities: Record<string, any[]>;
  onEntityProcessed: (entityType: string, result: any[]) => void;
  onContinue: () => void;
  onBack: () => void;
}> = ({
  entityRegistry,
  entityAddons,
  uploadedData,
  currentEntity,
  processedEntities,
  onEntityProcessed,
  onContinue,
  onBack
}) => {
  // eslint-disable-next-line
  const [isProcessing, setIsProcessing] = useState(false);

  const entityTypes = entityAddons.map(addon => addon.entityType);
  const currentEntityIndex = currentEntity ? entityTypes.indexOf(currentEntity.entityType) : -1;

  const handleEntityProcessed = (entityType: string, result: any[]) => {
    onEntityProcessed(entityType, result);
  };

  const renderCurrentEntityAddon = () => {
    if (!currentEntity) {
      return (
        <div className="entity-summary">
          <h3>{I18n.t("phrases.entityValidationComplete")}</h3>
          <p>{I18n.t("phrases.allEntitiesProcessed")}</p>

          {Object.entries(processedEntities).map(([entityType, entities], index) => (
            <div key={index} className="summary-item">
              <span className="summary-label">{entityRegistry[entityType]?.metadata.displayName || entityType}:</span>
              <span className="summary-value">{entities.length} items processed</span>
            </div>
          ))}

          <button className="navigation-button continue-button" style={{ marginTop: "20px" }} onClick={onContinue}>
            {I18n.t("phrases.continue")}
          </button>
        </div>
      );
    }

    return currentEntity.render(StepType.entityRelationValidation, {
      uploadedData,
      processedEntities,
      onComplete: (result: any[]) => handleEntityProcessed(currentEntity.entityType, result)
    });
  };

  return (
    <div className="entity-validation-container">
      <div className="title-container">
        <h2>{I18n.t("phrases.entityRelationValidation")}</h2>
      </div>

      <div className="progress-container">
        <EntityValidationProgress
          entityTypes={entityTypes}
          currentEntityIndex={currentEntityIndex}
          processedEntities={processedEntities}
          entityRegistry={entityRegistry}
        />
      </div>

      <div className="entity-content">
        {entityAddons.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">⚠️</div>
            <div className="empty-state-message">{I18n.t("phrases.noEntityAddonsConfigured")}</div>
          </div>
        ) : (
          renderCurrentEntityAddon()
        )}
      </div>

      {currentEntityIndex === 0 && (
        <div className="button-container">
          <button className="navigation-button back-button" onClick={onBack} disabled={isProcessing}>
            {I18n.t("phrases.back")}
          </button>
        </div>
      )}
    </div>
  );
};
